import type { SVGProps } from 'react';

const SvgHeartFilled = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox='0 0 24 24' fill='none' width='1em' height='1em' focusable='false' color='currentColor' {...props}>
    <path
      d='M7.95 4C5.21619 4 3 6.29558 3 9.12728C3 14.2546 8.85 18.9157 12 20C15.15 18.9157 21 14.2546 21 9.12728C21 6.29558 18.7838 4 16.05 4C14.3759 4 12.8958 4.86087 12 6.17853C11.1042 4.86087 9.62414 4 7.95 4Z'
      fill='currentColor'
    />
  </svg>
);
export default SvgHeartFilled;
